import { render } from "./espece.vue?vue&type=template&id=010df0e6&scoped=true"
import script from "./espece.vue?vue&type=script&lang=js"
export * from "./espece.vue?vue&type=script&lang=js"

import "./espece.vue?vue&type=style&index=0&id=010df0e6&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010df0e6"]])

export default __exports__